import React, { useEffect, useState } from 'react';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';
import axios from 'axios';
import { Loading, useNotify } from 'react-admin';
import FetchImage from '../image/FetchImage';
import { fetchMessagesJSON } from '../references';

const useStyles = makeStyles({
    table: {
        minWidth: 800,
    },
    chatSection: {
        width: '100%',
        height: '85vh'
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        height: '70vh',
        overflowY: 'auto'
    }
});


const Chat = (props) => {
    const classes = useStyles();
    const [message, setMessage] = useState('');
    const [listChatMessage, setListChatMessage] = useState([]);
    const { userId, listMessage, idDetFact, fetchMessages } = props;
    const notify = useNotify();

    useEffect(() => {
        setListChatMessage(listMessage);
    }, [listMessage]);

    useEffect(() => {
        fetchMessages();
    }, []);

    if (!userId) return <Loading />;

    const sendMessag = () => {
        fetchMessagesJSON(process.env.REACT_APP_URL + '/aerien/add_note', 'POST',
            JSON.stringify({ "cmd_id": "" + idDetFact + "", note: message })).
            then((response) => {
                if (response && response.status > 300) {
                    notify(response.message, 'warning');
                } else {
                    fetchMessages();
                }
            })
            .catch((e) => {
                notify(e, 'warning');
            });
        setMessage('');
    }

    const changed = (e) => {
        setMessage(e.target.value);
    }

    const keyUp = (e) => {
        if (e.keyCode === 13) {
            sendMessag();
        }
    }

    const fetchFile = (fileName, url) => {

        const config = {
            method: 'GET',
            url: url,
            responseType: 'blob', // important
            headers: {
                "Authorization": "Bearer " + localStorage.getItem('token')
            }
        };

        axios(config).then((response) => {
            var urlCreator = window.URL || window.webkitURL;
            const url = urlCreator.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
        });

    }

    return (
        <div >
            <Grid container component={Paper} className={classes.chatSection}>

                <Grid item xs={12}>
                    <List className={classes.messageArea}>

                        {listChatMessage.map((msg) => (
                            <ListItem key={msg.id}>
                                { msg.type === 'TXT' ?
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <ListItemText align={userId === msg.notedById ? "left" : "right"} secondary={msg.notedBy + '-' + msg.noteDate}></ListItemText>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <ListItemText align={userId === msg.notedById ? "left" : "right"} primary={msg.note}></ListItemText>
                                        </Grid>
                                    </Grid>
                                    :
                                    msg.type === 'PDF' ?
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <ListItemText align={userId === msg.notedById ? "left" : "right"} secondary={msg.notedBy + '-' + msg.noteDate} />
                                            </Grid>


                                            <ListItemAvatar align={userId === msg.notedById ? "left" : "right"} >
                                                <div onClick={() => fetchFile(msg.note, msg.fileDownloadUri)} style={{ color: '#1E90FF', cursor: 'pointer' }}>
                                                    {msg.note}
                                                </div>
                                            </ListItemAvatar>

                                        </Grid>
                                        :
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Grid item xs={12}>
                                                    <ListItemText align={userId === msg.notedById ? "left" : "right"} secondary={msg.notedBy + '-' + msg.noteDate}></ListItemText>
                                                </Grid>
                                                <ListItemAvatar align={userId === msg.notedById ? "left" : "right"}>

                                                    <ListItemAvatar align={userId === msg.notedById ? "left" : "right"}>
                                                        <div onClick={() => fetchFile(msg.note, msg.fileDownloadUri)} >
                                                            <FetchImage fileDownloadUri={msg.fileDownloadUri} />
                                                        </div>
                                                    </ListItemAvatar>

                                                </ListItemAvatar>
                                            </Grid>
                                        </Grid>
                                }
                            </ListItem>
                        ))
                        }
                    </List>
                    <Divider />
                    <Grid container style={{ padding: '20px' }}>
                        <Grid item xs={11}   >
                            <TextField id="outlined-basic-email" value={message} onKeyUp={(e) => keyUp(e)} label="Message" fullWidth onChange={(e) => changed(e)} />
                        </Grid>

                        <Grid item xs={1} align="right">
                            <Fab color="primary" aria-label="add" onClick={() => sendMessag()}><SendIcon /></Fab>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}

export default Chat;